import React, { useEffect } from "react";
import {
  FrVrfButton,
  FrVrfFooter,
  FrVrfMultipleLineInputField,
} from "@vrf/fr-vrf-web-components-react";
import { useGlobalNotifier, useMessage } from "@vrf/fr-vrf-core-react";
import { ApplicationMessageScreen } from "../../../messages/screen-message";
import { createModal } from "../../modal";
import { useMemoEditDialogState } from ".";
import { usePageNavigation } from "../../../pages/use-page-navigation";
import { useUpdateProjectMemo } from "../../../services/project";
import { useUpdateTicketStatusMemo } from "../../../services/ticket";

export enum MemoType {
  PROJECT = "P",
  TICKET_STATUS = "T",
}

export const MemoEditDialogContent = () => {
  const { showConfirmationDialog, resetUserError } = useGlobalNotifier();
  const { messageForScreen } = useMessage();
  const [dialogState, setDialogState] = useMemoEditDialogState();
  const { moveToModalPage, closeModalPage } = usePageNavigation();

  const [updateProjectMemoResponse, updateProjectMemoRequest] =
    useUpdateProjectMemo();
  const [updateTicketStatusMemoResponse, updateTicketStatusMemoRequest] =
    useUpdateTicketStatusMemo();

  const onInitialDisplayed = () => {
    moveToModalPage();
    resetUserError();
    setDialogState((prevState) => ({
      ...prevState,
      orgMmTxt: dialogState.mmTxt,
      isEdited: false,
    }));
    console.log(
      `- InitMemoDialog memoType[${dialogState.memoType}] pjtId[${dialogState.pjtId}]tcktTypeCd[${dialogState.tcktTypeCd}]tcktStsTypeCd[${dialogState.tcktStsTypeCd}]updateDateTime[${dialogState.updateDateTime}]`,
    );
  };
  useEffect(onInitialDisplayed, []);

  const valueChangeHandle = (event: CustomEvent) => {
    console.log("====dialogState valueChangeHandle====");
    const inputValue = event.detail.value;
    const isValid = event.detail.isValid;
    setDialogState((prevState) => ({
      ...prevState,
      mmTxt: inputValue,
      isEdited: true,
    }));
  };

  const onClickSave = () => {
    console.log(
      `- onClickSave memoType[${dialogState.memoType}] pjtId[${dialogState.pjtId}]tcktTypeCd[${dialogState.tcktTypeCd}]tcktStsTypeCd[${dialogState.tcktStsTypeCd}]updateDateTime[${dialogState.updateDateTime}]`,
    );

    resetUserError();

    if (dialogState.orgMmTxt === dialogState.mmTxt) {
      console.log("-- no change. close dialog");
      setDialogState((prevState) => ({
        ...prevState,
        isShow: false,
        isEdited: false,
      }));
      closeModalPage();
    }

    if (dialogState.memoType === MemoType.PROJECT) {
      const request = {
        pjtId: dialogState.pjtId,
        mmTxt: dialogState.mmTxt,
        updateDateTime: dialogState.updateDateTime,
      };
      updateProjectMemoRequest(request);
    }

    if (dialogState.memoType === MemoType.TICKET_STATUS) {
      const request = {
        pjtId: dialogState.pjtId,
        mmTxt: dialogState.mmTxt,
        updateDateTime: dialogState.updateDateTime,
        tcktTypeCd: dialogState.tcktTypeCd,
        tcktStsTypeCd: dialogState.tcktStsTypeCd,
      };
      updateTicketStatusMemoRequest(request);
    }
  };

  const onClickCancel = () => {
    if (!dialogState.isEdited) {
      setDialogState((prevState) => ({
        ...prevState,
        isShow: false,
        isEdited: false,
        mmTxt: dialogState.orgMmTxt,
        formValidation: true,
      }));
      closeModalPage();
      return;
    }
    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00033),
      onOkButtonClicked: () => {
        setDialogState((prevState) => ({
          ...prevState,
          mmTxt: dialogState.orgMmTxt,
          isShow: false,
          isEdited: false,
          formValidation: true,
        }));
        closeModalPage();
      },
    });
  };

  const onListenUpdateProjectMemoRequest = (): void => {
    if (!updateProjectMemoResponse) return;

    console.log("updateProjectMemoResponse");
    console.log(updateProjectMemoResponse);

    setDialogState((prevState) => ({
      ...prevState,
      updateDateTime: updateProjectMemoResponse.updateDateTime,
      isShow: false,
      isEdited: false,
    }));
    closeModalPage();
  };
  useEffect(onListenUpdateProjectMemoRequest, [updateProjectMemoResponse]);

  const onListenUpdateTicketStatusMemoResponse = (): void => {
    if (!updateTicketStatusMemoResponse) return;

    console.log("updateTicketStatusMemoResponse");
    console.log(updateTicketStatusMemoResponse);

    setDialogState((prevState) => ({
      ...prevState,
      updateDateTime: updateTicketStatusMemoResponse.updateDateTime,
      isShow: false,
      isEdited: false,
    }));
    closeModalPage();
  };
  useEffect(onListenUpdateTicketStatusMemoResponse, [
    updateTicketStatusMemoResponse,
  ]);

  return (
    <>
      {createModal(
        "Edit Memo",
        <div>
          <div>
            <FrVrfMultipleLineInputField
              labelContent="Memo"
              placeholder="Please input..."
              content={dialogState.mmTxt}
              resize="both"
              style={{
                "--vrf-multiple-line-input-field-label-width": "100px",
                "--vrf-multiple-line-input-field-input-height": "400px",
                "--vrf-multiple-line-input-field-input-width": "800px",
              }}
              clearButtonVisible={true}
              onInputValueChanged={valueChangeHandle}
              constraint="Size(value, {min: 0, max: 500000})"
            />
          </div>
          <FrVrfFooter>
            <FrVrfButton
              content="Cancel"
              theme="secondary"
              size="large"
              onClicked={onClickCancel}
            />
            <FrVrfButton
              content="Save"
              theme="primary"
              size="large"
              onClicked={onClickSave}
            />
          </FrVrfFooter>
        </div>,
        () => {},
        "medium",
      )}
    </>
  );
};
